var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.placeholder,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }